module.exports = __webpack_public_path__ + "img/menuDetail1.2592baff.png";